(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("base"), require("core"), require("ui"), require("module-metro-common"));
	else if(typeof define === 'function' && define.amd)
		define(["base", "core", "ui", "module-metro-common"], factory);
	else if(typeof exports === 'object')
		exports["widget-metro-notifications"] = factory(require("base"), require("core"), require("ui"), require("module-metro-common"));
	else
		root["widget-metro-notifications"] = factory(root["base"], root["core"], root["ui"], root["module-metro-common"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_6__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'widget-notifications';
	    var base = __webpack_require__(3);
	    var core = __webpack_require__(4);
	    var ui = __webpack_require__(5);
	    var common = __webpack_require__(6);

	    var deps = [core.name, ui.name, common.name];

	    // @ngInject
	    function run(lpWidget) {
	        // run widget
	    }

	    module.exports = base.createModule(module.name, deps).constant(__webpack_require__(7)).controller(__webpack_require__(8)).factory(__webpack_require__(9)).directive(__webpack_require__(10)).run(run);
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    exports.widgetPrefs = {
	        NOTIFICATIONS_ENDPOINT: 'notificationsEndpoint',
	        CLOSE_NOTIFICATION_ENDPOINT: 'closeNotificationEndpoint',
	        POLL_INTERVAL: 'pollInterval',
	        ALLOW_PUBSUB: 'allowPubsub'
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var applyScope = function applyScope($scope) {
	        if (!$scope.$$phase) {
	            $scope.$apply();
	        }
	    };

	    var queue = __webpack_require__(3).queue;

	    // @ngInject
	    exports.NotificationsController = function ($scope, $rootElement, lpWidget, lpPortal, lpCoreHttpInterceptor, widgetPrefs, NotificationsModel, i18nUtils, lpCoreBus, lpCoreUtils, $http, metroContext) {

	        var bus = lpCoreBus;

	        var vm = this;

	        // Template to render notifications
	        this.template = 'templates/type-panel.html';
	        this.closeAllButton = false;

	        //i18n
	        this.locale = 'en-US';
	        this.offsetTopCorrection = {};
	        this.offsetMarginCorrection = {};

	        //get all the prefs
	        this.fixedBar = lpCoreUtils.parseBoolean(lpWidget.getPreference('fixedBar'));

	        var notificationsEndpoint = lpWidget.getPreference(widgetPrefs.NOTIFICATIONS_ENDPOINT);
	        var closeNotificationEndpoint = lpWidget.getPreference(widgetPrefs.CLOSE_NOTIFICATION_ENDPOINT);
	        var allowPubsub = lpCoreUtils.parseBoolean(lpWidget.getPreference(widgetPrefs.ALLOW_PUBSUB));
	        var placeholder;
	        //var pollInterval = parseInt(lpWidget.getPreference(widgetPrefs.POLL_INTERVAL), 10);

	        // Prevent notifications about notifications :)
	        lpCoreHttpInterceptor.configureNotifications({
	            ignore: [notificationsEndpoint]
	        });

	        //construct and initialize the model
	        var model = NotificationsModel.getInstance({
	            notificationsEndpoint: notificationsEndpoint,
	            closeNotificationEndpoint: closeNotificationEndpoint,
	            onNotificationAdded: function onNotificationAdded(notification) {
	                //this callback is fired when a new notification is added, which in turn fires
	                //an event on the bdom, so parent containers are aware
	                //For example the launcher container modifies its scroll position to accommodate the new message
	                lpWidget.model.fireEvent('notification-added', true, true, {
	                    notification: notification
	                });
	            }
	        });
	        this.model = model;

	        function addNotification(data) {
	            if (data.notification) {

	                var notification = data.notification;

	                var add = function add(not) {
	                    // Notification main container template

	                    // if error message, get the error message
	                    if (!not.message && not.data && not.data.message[0] && not.data.message[0]) {
	                        var error = not.data.message[0];
	                        not.message = error.message ? error.message : error.detail;
	                    }

	                    if (not.container && not.container.type) {
	                        vm.template = 'templates/type-' + not.container.type + '.html';
	                    }

	                    //// Merge notification content template data into notification object (for legacy config  support)
	                    //if (typeof not.data === 'object' || not.data) {
	                    //    window.angular.extend(not, not.data);
	                    //}

	                    //if (not.closable && !not.links) {
	                    if (!not.links) {
	                        not.links = [{
	                            rel: 'Close',
	                            action: function action() {
	                                vm.closeNotification(not);
	                            }
	                        }];
	                    }

	                    if (!not.icon) {
	                        not.icon = 'cogs';
	                    }

	                    model.addNotification(data.notification);

	                    // Show/hide close all button
	                    vm.closeAllButton = !model.notifications.some(function (n) {
	                        return !n.closable;
	                    });

	                    applyScope($scope);
	                };

	                if (notification.type !== 'local') {

	                    var category = notification.category;
	                    var notificationUrl = b$.portal.config.serverRoot;
	                    if (category) {
	                        notificationUrl += '/services/rest/notifications/' + category + '/' + notification.id;
	                    } else {
	                        notificationUrl += '/services/rest/notifications/' + notification.id;
	                    }

	                    //// Get notification from CS
	                    $http.get(notificationUrl).then(function (response) {
	                        if (response.status === 200) {
	                            var serverNotification = response.data;
	                            if (placeholder) {
	                                for (var i = 0; i < placeholder.length; i++) {
	                                    var keyName = Object.keys(placeholder[i]);
	                                    serverNotification.message = serverNotification.message.replace("{{" + keyName + "}}", placeholder[i][keyName]);
	                                }
	                                placeholder = "";
	                            }
	                            serverNotification.data = {
	                                message: serverNotification.message
	                            };
	                            angular.extend(notification, serverNotification);
	                            add(notification);
	                        }
	                    }, function (response) {
	                        add(notification);
	                    });
	                } else {
	                    add(notification);
	                }
	            }
	        }

	        // don't call loadNotifications or start polling if the user is not logged in
	        //if (lpPortal.userId !== 'null') {
	        //    model.loadNotifications();
	        //
	        //    // polling interval lower than 1 second is not supported, and
	        //    // if endpoint pref is not defined we will not go polling
	        //    if (!isNaN(pollInterval) && pollInterval > 999 && notificationsEndpoint) {
	        //        model.startPolling(pollInterval);
	        //    }
	        //}

	        if (allowPubsub) {
	            queue.onPush(function (context, retryObject) {

	                /**
	                 * @property context.messages {Array}
	                 * @property context.messages[0].message {String}
	                 * @param context.contextId {String}
	                 */

	                var notificationIdPrefix = 'launchpad-widget-notification-retry_';
	                var notificationId = notificationIdPrefix + context.contextId;
	                var existingNotification = model.getNotificationById(notificationId);

	                if (existingNotification) {
	                    existingNotification.data.message = existingNotification.data.message.concat(context.messages);
	                    applyScope($scope);
	                } else {
	                    // create new notification
	                    addNotification({
	                        notification: {
	                            id: notificationId,
	                            level: context.notification && context.notification.level || 'severe',
	                            data: {
	                                message: [].concat(context.messages)
	                            },
	                            container: {
	                                // type: 'overlay',
	                                template: 'templates/retry.html'
	                            },
	                            retry: {
	                                action: function action() {
	                                    queue.retry(retryObject).then(function () {
	                                        vm.closeNotification({ id: notificationId });
	                                    });
	                                },
	                                cancel: function cancel() {
	                                    queue.cancel(retryObject).then(function () {
	                                        vm.closeNotification({ id: notificationId });
	                                    });
	                                }
	                            }
	                        }
	                    });
	                }
	            });

	            bus.subscribe('launchpad.add-notification', function (data) {

	                var notification = data.notification;

	                // check if notification already is shown:
	                var existingNotification = model.getNotificationById(notification.id);

	                if (existingNotification) {
	                    // Only Update Message
	                    existingNotification.message = notification.message;
	                    applyScope($scope);
	                } else {
	                    addNotification(data);
	                }
	            });

	            bus.subscribe('launchpad.add-notifications', function (notifications) {
	                placeholder = notifications.placeholder;
	                for (var i = 0; i < notifications.length; i++) {
	                    // notification is already processed from SC. So set local to true to prevent overriding
	                    notifications[i].local = true;
	                    addNotification({ notification: notifications[i] });
	                }
	                applyScope($scope);
	            });

	            bus.subscribe('launchpad.remove-notification', function (data) {
	                if (data.notification && data.notification.id) {
	                    model.removeNotification(data.notification.id);
	                    applyScope($scope);
	                }
	            });

	            bus.subscribe('launchpad.remove-all-notifications', function () {
	                vm.closeAllNotifications();
	            });

	            bus.subscribe('launchpad-retail.offsetTopCorrection', function (data) {
	                if (data.offsetTopCorrection >= 0) {
	                    vm.offsetTopCorrection = {
	                        top: data.offsetTopCorrection
	                    };
	                    vm.offsetMarginCorrection = !vm.fixedBar ? {
	                        top: data.offsetTopCorrection
	                    } : {};
	                    applyScope($scope);
	                }
	            });
	        }

	        /**
	         * Get valid Bootstrap class name for notification by its level property.
	         * Possible values for notification levels: info (default), severe, warning, success.
	         * @param notification {Object}
	         * @return {string}
	         */
	        this.getAlertClass = model.getAlertClass;

	        this.isDesignMode = function () {
	            return lpPortal.designMode;
	        };

	        this.closeNotification = function (notification) {
	            model.closeNotification(notification).then(function () {
	                if (model.notifications.length > 0) {
	                    $scope.$broadcast('lp.notifications.focus');
	                }
	            });
	        };

	        this.closeAllNotifications = function () {
	            model.notifications.forEach(function (notification) {
	                model.closeNotification(notification);
	            });
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    // @ngInject

	    exports.NotificationsModel = function ($rootScope, $timeout, httpService) {
	        var NotificationsModel = function NotificationsModel(config) {

	            config = config || {};
	            this.notifications = [];
	            this.notificationsEndpoint = config.notificationsEndpoint;
	            this.closeNotificationEndpoint = config.closeNotificationEndpoint;
	            this.updateReceivedEndpoint = config.updateReceivedEndpoint;
	            this.polling = false;
	            this.onNotificationAdded = config.onNotificationAdded;
	            this.loading = false;
	        };

	        NotificationsModel.prototype.startPolling = function (pollInterval) {

	            var self = this;

	            if (this.polling) {
	                return;
	            }
	            this.polling = true;

	            var load = function load() {
	                var xhr = self.loadNotifications();
	                xhr.success(function () {
	                    self.pollingTimeout = $timeout(function () {
	                        load();
	                    }, pollInterval);
	                });
	            };

	            this.pollingTimeout = $timeout(function () {
	                load();
	            }, pollInterval);
	        };

	        NotificationsModel.prototype.stopPolling = function () {
	            if (this.pollingTimeout) {
	                $timeout.cancel(this.pollingTimeout);
	                this.polling = false;
	            }
	        };

	        NotificationsModel.prototype.loadNotifications = function () {

	            var self = this;
	            var getMessagesService = httpService.getInstance({
	                endpoint: this.notificationsEndpoint,
	                cacheTimeout: 0
	            });

	            this.loading = true;

	            var xhr = getMessagesService.read();

	            xhr.success(function (data) {
	                if (data.messages) {
	                    data.messages.forEach(function (message) {
	                        message.className = self.getAlertClass(message);
	                        self.addNotification(message);
	                    });
	                }
	            });

	            xhr.error(function (data) {
	                if (data.errors) {
	                    self.errorCode = data.errors[0];
	                }
	            });

	            xhr['finally'](function () {
	                self.loading = false;
	            });

	            return xhr;
	        };

	        NotificationsModel.prototype.getAlertClass = function (notification) {
	            var level = notification.level.toLowerCase();
	            var is = ['info', 'severe', 'warning', 'success'].indexOf(level) > -1;

	            level = level === 'severe' ? 'danger' : level;
	            return 'alert-' + (is ? level : 'info');
	        };

	        NotificationsModel.prototype.addNotification = function (notification) {
	            if (typeof notification.id !== 'string' && typeof notification.id !== 'number') {
	                return;
	            }

	            var replaced = false;
	            for (var i = 0; i < this.notifications.length && !replaced; i++) {
	                var existingNotification = this.notifications[i];

	                if (notification.id && existingNotification.id === notification.id || existingNotification.message === notification.message) {
	                    this.notifications[i] = notification;
	                    replaced = true;
	                }
	            }
	            if (!replaced) {
	                this.notifications.push(notification);

	                if (typeof this.onNotificationAdded === 'function') {
	                    this.onNotificationAdded.call(null, notification);
	                }
	            }
	        };

	        NotificationsModel.prototype.removeNotification = function (notificationId) {
	            var notification = this.notifications.filter(function (n) {
	                return n.id === notificationId;
	            });
	            if (notification.length) {
	                this.notifications.splice(this.notifications.indexOf(notification[0]), 1);
	            }
	        };

	        NotificationsModel.prototype.closeNotification = function (notification) {
	            var self = this;
	            var closeOnServer = function closeOnServer() {
	                self.removeNotification(notification.id);
	            };

	            var safeToClose = function safeToClose() {
	                return $timeout(function () {
	                    if (!self.loading) {
	                        closeOnServer();
	                    } else {
	                        safeToClose();
	                    }
	                }, 100);
	            };
	            return safeToClose();
	        };

	        NotificationsModel.prototype.getNotificationById = function (id) {
	            return this.notifications.filter(function (notification) {
	                return notification.id === id;
	            })[0] || null;
	        };

	        return {
	            getInstance: function getInstance(config) {
	                return new NotificationsModel(config);
	            }
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    exports.mbMessageValues = function () {
	        return {
	            link: function link($scope, element, attrs) {
	                var notification = $scope.notification;
	                var message = notification.message;
	                element.html(message);
	            }
	        };
	    };

	    // @ngInject
	    exports.lpAllowPubsubClick = function (lpCoreBus, lpCoreUtils) {
	        return {
	            restrict: 'A',
	            scope: {
	                numberAllowed: '@lpAllowPubsubClick',
	                invokerClassName: '@'
	            },
	            link: function link($scope, element, attrs) {
	                var bus = lpCoreBus;
	                $scope.numberAllowed = parseInt($scope.numberAllowed, 10) || 0;
	                $scope.invokerClassName = $scope.invokerClassName || 'pubsub-invoker';

	                if ($scope.numberAllowed > 0 && $scope.invokerClassName) {
	                    $scope.invokers = element[0].querySelectorAll('.' + $scope.invokerClassName);

	                    lpCoreUtils.forEach($scope.invokers, function (el, index) {
	                        if (index < $scope.numberAllowed) {
	                            el.addEventListener('click', function (e) {
	                                var eventName = e.target.getAttribute('data-pubsub-name');
	                                var args = e.target.getAttribute('data-pubsub-arguments');

	                                if (eventName) {
	                                    bus.publish(eventName, args);
	                                }
	                            });
	                        }
	                    });
	                }
	            }
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// scripts/main.js